let language = {
    "A1102B2000090": "您的操作已被中断，因为操作过于频繁。请刷新页面并稍等片刻后重试。",
    "A1102N001": "我们需要在此页面使用 Google reCaptcha，但您似乎无法连接到 Google。",
    "A1102B2000080": "在尝试登录时遇到网络错误。请点击“重试”或刷新页面再次尝试。如果问题仍然存在，请联系支持团队 {{websiteEmail}} 获取进一步帮助。对此带来的不便，我们深感歉意。",
    
    "A1102B2000068": "似乎是浏览器缓存引起了问题。\n请按 Ctrl+F5（Windows）或 Command+R（Mac）清除缓存后重试登录。\n如果问题仍然存在，请随时联系我们的支持团队，我们将很乐意提供进一步的帮助。谢谢！",
    
    "CONNECTION-FAIL-TITLE": "连接失败",
};

export { language }
